// extracted by mini-css-extract-plugin
export default {"tag-group":"styles_tag-group__T7fw1","tag-list":"styles_tag-list__6Qlzw","tag":"styles_tag__IB6e-"};